export default __webpack_public_path__ + "static/images/ac4ddbbd519f7a6b7a54b2bd617a8b58.png";